// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2VmYs","label":"Section_label__2Zm72","contentWrap":"Section_contentWrap__5VCEE","footer":"Section_footer__1_Ihz","footerInner":"Section_footerInner__1RF5s"};